/**
 * @namespace {BX.Salescenter}
 */
export default class FeedbackType
{
	static FEEDBACK = 'feedback';
	static PAY_ORDER = 'pay_order';
	static PAYSYSTEM_OFFER = 'paysystem_offer';
	static PAYSYSTEM_SBP_OFFER = 'paysystem_sbp_offer';
	static SMSPROVIDER_OFFER = 'smsprovider_offer';
	static DELIVERY_OFFER = 'delivery_offer';
	static TERMINAL_OFFER = 'terminal_offer';
	static INTEGRATION_REQUEST = 'integration_request';
}
